// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1064":"ac6a0904","4341":"864362d0","6485":"864362d0","9895":"864362d0"}[chunkId] + ".chunk.css";
};